import { useIntl } from "react-intl";

import testIds from "constants/testIds";
import { formatWeight } from "helpers/commonHelpers";
import type { QuoteMeasurementSummary as QuoteMeasurementSummaryType } from "api/response/quotation.response";

import "./costDetails.scss";

type QuoteMeasurementSummaryProps = {
  summary?: QuoteMeasurementSummaryType | null;
};

const formatCbmDisplay = (value: number) => {
  const text = Number(value).toFixed(10).replace(/\.?0+$/, "");
  return `${text === "-0" ? "0" : text} m³`;
};

function QuoteMeasurementSummary({ summary }: QuoteMeasurementSummaryProps) {
  const intl = useIntl();

  if (!summary) return null;

  const { chargeable_weight: chargeableWeight, total_cbm: totalCbm } = summary;
  if (!chargeableWeight && !totalCbm) return null;

  const chargeableWeightLabel = intl.formatMessage({
    id: "quote-request.costDetailChargeableWeight",
    defaultMessage: "Chargeable weight",
  });
  const totalCbmLabel = intl.formatMessage({
    id: "quote.totalCBM",
    defaultMessage: "Total CBM",
  });

  return (
    <div className="quote-measurement-summary-card">
      <div className="quote-measurement-summary">
      {chargeableWeight && (
        <div className="quote-measurement-summary__item">
          <div className="quote-measurement-summary__label font-b2 text-secondary">{chargeableWeightLabel}</div>
          <div
            className="quote-measurement-summary__value font-b3"
            data-testid={testIds.SHIPMENT_DASHBOARD_QUOTE_CHARGEABLE_WEIGHT}
          >
            {formatWeight(chargeableWeight.value, chargeableWeight.unit)}
          </div>
        </div>
      )}
      {totalCbm && (
        <div className="quote-measurement-summary__item">
          <div className="quote-measurement-summary__label font-b2 text-secondary">{totalCbmLabel}</div>
          <div className="quote-measurement-summary__value font-b3" data-testid={testIds.SHIPMENT_DASHBOARD_QUOTE_TOTAL_CBM}>
            {formatCbmDisplay(totalCbm.value)}
          </div>
        </div>
      )}
      </div>
    </div>
  );
}

export default QuoteMeasurementSummary;
